function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Path_31921",
  "data-name": "Path 31921",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32408",
  "data-name": "Path 32408",
  d: "M17.921,21.342h-14A3.425,3.425,0,0,1,.5,17.921v-14A3.425,3.425,0,0,1,3.921.5h14a3.425,3.425,0,0,1,3.421,3.421v14A3.425,3.425,0,0,1,17.921,21.342Z",
  transform: "translate(0.079 0.079)",
  fill: "#f7e1cf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32409",
  "data-name": "Path 32409",
  d: "M4,1.158A2.845,2.845,0,0,0,1.158,4V18A2.845,2.845,0,0,0,4,20.842H18A2.845,2.845,0,0,0,20.842,18V4A2.845,2.845,0,0,0,18,1.158H4M4,0H18a4,4,0,0,1,4,4V18a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
  fill: "#f29960"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "check",
  transform: "translate(4.635 5.789)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_29413",
  "data-name": "Path 29413",
  d: "M20.2,11.035a1.2,1.2,0,1,1,1.714,1.68L15.53,20.7a1.2,1.2,0,0,1-1.728.032L9.571,16.493a1.2,1.2,0,1,1,1.7-1.7l3.35,3.347,5.558-7.078a.377.377,0,0,1,.032-.035Z",
  transform: "translate(-9.185 -10.675)",
  fill: "#696969",
  fillRule: "evenodd"
}));

function SvgNewCheckboxSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "new-checkbox-select",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCheckboxSelect);
export default __webpack_public_path__ + "static/media/new-checkbox-select.4ba1737d.svg";
export { ForwardRef as ReactComponent };